import SingleActiveOrderPage from "./SingleActiveOrderPage";

export default SingleActiveOrderPage;
